import { cn as e } from "../cn.js";
import { dot as t, dotsContainer as n, loadingContainer as r, overlay as i, skeleton as a, spinner as o } from "./styles.js";
import * as s from "react";
import { jsx as c, jsxs as l } from "react/jsx-runtime";
// src/design/loading/index.tsx
var u = s.forwardRef(({ className: t, size: n = "md", variant: r = "primary", text: i, textPosition: a = "bottom", ...s }, u) => {
	let d = /* @__PURE__ */ c("div", {
		...i ? null : {
			ref: u,
			...s
		},
		className: e(o({
			size: n,
			variant: r
		}), t),
		role: "status",
		"aria-label": "Loading"
	});
	return i ? /* @__PURE__ */ l("div", {
		ref: u,
		className: e("flex items-center gap-3", a === "bottom" && "flex-col"),
		...s,
		children: [d, /* @__PURE__ */ c("span", {
			className: "text-sm text-muted-foreground",
			children: i
		})]
	}) : d;
});
u.displayName = "Loading.Spinner";
var d = s.forwardRef(({ className: r, size: i = "md", variant: a = "primary", count: o = 3, ...s }, l) => /* @__PURE__ */ c("div", {
	ref: l,
	className: e(n({ size: i }), r),
	role: "status",
	"aria-label": "Loading",
	...s,
	children: Array.from({ length: o }).map((n, r) => /* @__PURE__ */ c("div", {
		className: e(t({
			size: i,
			variant: a
		})),
		style: { animationDelay: `${r * .15}s` }
	}, r))
}));
d.displayName = "Loading.Dots";
var f = s.forwardRef(({ className: t, variant: n = "rect", width: r, height: i, circle: o, style: s, ...l }, u) => /* @__PURE__ */ c("div", {
	ref: u,
	className: e(a({ variant: o ? "circle" : n }), t),
	style: {
		width: r,
		height: i || (o ? r : void 0),
		...s
	},
	role: "status",
	"aria-label": "Loading",
	...l
}));
f.displayName = "Loading.Skeleton";
var p = s.forwardRef(({ className: t, showImage: n = !1, showFooter: r = !1, lines: i = 3, ...a }, o) => /* @__PURE__ */ l("div", {
	ref: o,
	className: e("rounded-lg border border-border bg-card p-4", t),
	...a,
	children: [
		n && /* @__PURE__ */ c(f, {
			className: "w-full h-48 mb-4",
			variant: "rect"
		}),
		/* @__PURE__ */ l("div", {
			className: "space-y-3",
			children: [
				/* @__PURE__ */ c(f, {
					className: "h-6 w-3/4",
					variant: "rounded"
				}),
				/* @__PURE__ */ c(f, {
					className: "h-4 w-1/2",
					variant: "rounded"
				}),
				/* @__PURE__ */ c("div", {
					className: "space-y-2 pt-2",
					children: Array.from({ length: i }).map((e, t) => /* @__PURE__ */ c(f, {
						className: "h-4",
						style: { width: t === i - 1 ? "60%" : "100%" },
						variant: "text"
					}, t))
				})
			]
		}),
		r && /* @__PURE__ */ l("div", {
			className: "flex gap-2 mt-4 pt-4 border-t border-border",
			children: [/* @__PURE__ */ c(f, {
				className: "h-9 w-20",
				variant: "rounded"
			}), /* @__PURE__ */ c(f, {
				className: "h-9 w-24",
				variant: "rounded"
			})]
		})
	]
}));
p.displayName = "Loading.CardSkeleton";
var m = s.forwardRef(({ className: t, showFooter: n = !0, ...r }, i) => /* @__PURE__ */ l("div", {
	ref: i,
	className: e("rounded-lg bg-card shadow-lg border border-border p-6 max-w-md w-full", t),
	...r,
	children: [
		/* @__PURE__ */ l("div", {
			className: "space-y-2 pb-4 border-b border-border",
			children: [/* @__PURE__ */ c(f, {
				className: "h-6 w-2/3",
				variant: "rounded"
			}), /* @__PURE__ */ c(f, {
				className: "h-4 w-full",
				variant: "text"
			})]
		}),
		/* @__PURE__ */ l("div", {
			className: "space-y-4 py-6",
			children: [
				/* @__PURE__ */ l("div", {
					className: "space-y-2",
					children: [/* @__PURE__ */ c(f, {
						className: "h-4 w-1/4",
						variant: "rounded"
					}), /* @__PURE__ */ c(f, {
						className: "h-10 w-full",
						variant: "rounded"
					})]
				}),
				/* @__PURE__ */ l("div", {
					className: "space-y-2",
					children: [/* @__PURE__ */ c(f, {
						className: "h-4 w-1/3",
						variant: "rounded"
					}), /* @__PURE__ */ c(f, {
						className: "h-10 w-full",
						variant: "rounded"
					})]
				}),
				/* @__PURE__ */ l("div", {
					className: "space-y-2",
					children: [/* @__PURE__ */ c(f, {
						className: "h-4 w-1/2",
						variant: "rounded"
					}), /* @__PURE__ */ c(f, {
						className: "h-20 w-full",
						variant: "rounded"
					})]
				})
			]
		}),
		n && /* @__PURE__ */ l("div", {
			className: "flex gap-2 justify-end pt-4 border-t border-border",
			children: [/* @__PURE__ */ c(f, {
				className: "h-9 w-20",
				variant: "rounded"
			}), /* @__PURE__ */ c(f, {
				className: "h-9 w-24",
				variant: "rounded"
			})]
		})
	]
}));
m.displayName = "Loading.ModalSkeleton";
var h = s.forwardRef(({ className: t, position: n = "right", showFooter: r = !0, ...i }, a) => /* @__PURE__ */ l("div", {
	ref: a,
	className: e("bg-card border-border h-full w-full max-w-md flex flex-col", n === "left" ? "border-r" : "border-l", t),
	...i,
	children: [
		/* @__PURE__ */ c("div", {
			className: "p-6 border-b border-border",
			children: /* @__PURE__ */ c(f, {
				className: "h-6 w-1/2",
				variant: "rounded"
			})
		}),
		/* @__PURE__ */ l("div", {
			className: "flex-1 p-6 space-y-6 overflow-auto",
			children: [
				/* @__PURE__ */ l("div", {
					className: "space-y-3",
					children: [/* @__PURE__ */ c(f, {
						className: "h-4 w-1/4",
						variant: "rounded"
					}), /* @__PURE__ */ c(f, {
						className: "h-10 w-full",
						variant: "rounded"
					})]
				}),
				/* @__PURE__ */ l("div", {
					className: "space-y-3",
					children: [/* @__PURE__ */ c(f, {
						className: "h-4 w-1/3",
						variant: "rounded"
					}), /* @__PURE__ */ c(f, {
						className: "h-10 w-full",
						variant: "rounded"
					})]
				}),
				/* @__PURE__ */ l("div", {
					className: "space-y-3",
					children: [/* @__PURE__ */ c(f, {
						className: "h-4 w-1/2",
						variant: "rounded"
					}), /* @__PURE__ */ c(f, {
						className: "h-32 w-full",
						variant: "rounded"
					})]
				}),
				/* @__PURE__ */ c("div", {
					className: "space-y-2",
					children: Array.from({ length: 4 }).map((e, t) => /* @__PURE__ */ c(f, {
						className: "h-4 w-full",
						variant: "text"
					}, t))
				})
			]
		}),
		r && /* @__PURE__ */ l("div", {
			className: "p-6 border-t border-border flex gap-2 justify-end",
			children: [/* @__PURE__ */ c(f, {
				className: "h-9 w-20",
				variant: "rounded"
			}), /* @__PURE__ */ c(f, {
				className: "h-9 w-24",
				variant: "rounded"
			})]
		})
	]
}));
h.displayName = "Loading.DrawerSkeleton";
var g = s.forwardRef(({ className: t, rows: n = 5, columns: r = 4, showHeader: i = !0, ...a }, o) => {
	let s = { gridTemplateColumns: `repeat(${r}, minmax(0, 1fr))` };
	return /* @__PURE__ */ l("div", {
		ref: o,
		className: e("rounded-lg border border-border bg-card overflow-hidden", t),
		...a,
		children: [i && /* @__PURE__ */ c("div", {
			className: "grid gap-4 p-4 border-b border-border bg-muted",
			style: s,
			children: Array.from({ length: r }).map((e, t) => /* @__PURE__ */ c(f, {
				className: "h-4",
				variant: "rounded"
			}, t))
		}), /* @__PURE__ */ c("div", {
			className: "divide-y divide-border",
			children: Array.from({ length: n }).map((e, t) => /* @__PURE__ */ c("div", {
				className: "grid gap-4 p-4",
				style: s,
				children: Array.from({ length: r }).map((e, t) => /* @__PURE__ */ c(f, {
					className: "h-4",
					variant: "text"
				}, t))
			}, t))
		})]
	});
});
g.displayName = "Loading.TableSkeleton";
var _ = s.forwardRef(({ className: t, fullScreen: n = !1, text: a, spinnerSize: o = "lg", spinnerVariant: s = "primary", type: f = "spinner", ...p }, m) => {
	let h = o === "2xl" ? "xl" : o;
	return /* @__PURE__ */ c("div", {
		ref: m,
		className: e(r({
			fullScreen: n,
			centered: !0
		}), !n && i({ rounded: !1 }), t),
		...p,
		children: /* @__PURE__ */ l("div", {
			className: "flex flex-col items-center gap-3",
			children: [f === "spinner" ? /* @__PURE__ */ c(u, {
				size: o,
				variant: s
			}) : /* @__PURE__ */ c(d, {
				size: h,
				variant: s
			}), a && /* @__PURE__ */ c("span", {
				className: "text-sm text-muted-foreground font-medium",
				children: a
			})]
		})
	});
});
_.displayName = "Loading.Overlay";
var v = s.forwardRef(({ ...e }, t) => /* @__PURE__ */ c(u, {
	ref: t,
	...e
}));
v.displayName = "Loading", v.Spinner = u, v.Dots = d, v.Skeleton = f, v.CardSkeleton = p, v.ModalSkeleton = m, v.DrawerSkeleton = h, v.TableSkeleton = g, v.Overlay = _;
export { v as Loading };

//# sourceMappingURL=index.js.map